export const ROWS_PER_PAGE = 25;

export const EVENTS_PER_PAGE = 10;

export const REQUIRED_CSV_COLUMNS = ['FirstName', 'LastName', 'Email'];

export const CSV_EXPORT_HEADERS = [
  'RegistrationId', 'Email', 'FirstName', 'LastName',
  'RegistrationStatus', 'DateCreated', 'Notes', 'Membership', 'Title',
];

export const VALID_EMAIL_DOMAIN = 'ucla.edu';
